import type { AppData } from './types'

const STORAGE_KEY = 'saola-feedback-v1'

const today = new Date().toISOString().slice(0, 10)

export const demoData: AppData = {
  schemaVersion: 1,
  students: [
    { id: 'student-lan', name: 'Nguyễn Minh Lan', targetBand: 7, note: 'Mục tiêu thi tháng 12', createdAt: today },
    { id: 'student-khang', name: 'Trần Gia Khang', targetBand: 6.5, note: 'Tập trung Reading và Speaking', createdAt: today },
  ],
  assessments: [
    {
      id: 'demo-sp-1', studentId: 'student-lan', skill: 'speaking', date: '2026-09-12', status: 'completed', context: 'Mock test 1',
      criteria: [
        { key: 'fc', label: 'Fluency & Coherence', score: 6 }, { key: 'lr', label: 'Lexical Resource', score: 6.5 },
        { key: 'gra', label: 'Grammatical Range & Accuracy', score: 6 }, { key: 'pr', label: 'Pronunciation', score: 6.5 },
      ], overall: 6.5, generalComment: 'Ý rõ, cần giảm tự sửa.', nextGoal: 'Duy trì câu trả lời Part 2 đủ hai phút.', createdAt: today, updatedAt: today,
    },
    {
      id: 'demo-sp-2', studentId: 'student-lan', skill: 'speaking', date: '2026-10-03', status: 'completed', context: 'Progress check',
      criteria: [
        { key: 'fc', label: 'Fluency & Coherence', score: 6.5 }, { key: 'lr', label: 'Lexical Resource', score: 7 },
        { key: 'gra', label: 'Grammatical Range & Accuracy', score: 6.5 }, { key: 'pr', label: 'Pronunciation', score: 6.5 },
      ], overall: 6.5, generalComment: 'Từ vựng linh hoạt hơn.', nextGoal: 'Luyện stress và chunking trong câu dài.', createdAt: today, updatedAt: today,
    },
    {
      id: 'demo-wr-1', studentId: 'student-lan', skill: 'writing', date: '2026-09-28', status: 'completed', context: 'Academic Task 2', subtype: 'Task 2',
      criteria: [
        { key: 'tr', label: 'Task Achievement / Response', score: 6.5 }, { key: 'cc', label: 'Coherence & Cohesion', score: 6 },
        { key: 'lr', label: 'Lexical Resource', score: 6.5 }, { key: 'gra', label: 'Grammatical Range & Accuracy', score: 6 },
      ], overall: 6.5, generalComment: 'Lập luận đủ nhưng đoạn 2 chưa phát triển.', nextGoal: 'Mỗi body paragraph có claim, explanation và example.', createdAt: today, updatedAt: today,
    },
    {
      id: 'demo-re-1', studentId: 'student-lan', skill: 'reading', date: '2026-10-05', status: 'completed', context: 'Cambridge practice', subtype: 'Academic · Full test',
      questionTypes: [
        { key: 'matching-headings', label: 'Matching Headings', correct: 5, total: 8 },
        { key: 't-f-ng', label: 'True / False / Not Given', correct: 7, total: 10 },
        { key: 'completion', label: 'Sentence Completion', correct: 8, total: 8 },
      ], overall: 73, nextGoal: 'Phân biệt main idea và supporting detail.', createdAt: today, updatedAt: today,
    },
    {
      id: 'demo-li-1', studentId: 'student-lan', skill: 'listening', date: '2026-10-07', status: 'completed', context: 'Section practice', subtype: 'Parts 2–3',
      questionTypes: [
        { key: 'map', label: 'Plan / Map / Diagram Labelling', correct: 6, total: 8 },
        { key: 'mc', label: 'Multiple Choice', correct: 5, total: 8 },
      ], overall: 69, nextGoal: 'Đánh dấu hướng và điểm mốc trước khi nghe.', createdAt: today, updatedAt: today,
    },
  ],
}

function isAppData(value: unknown): value is AppData {
  if (!value || typeof value !== 'object') return false
  const data = value as Partial<AppData>
  return data.schemaVersion === 1 && Array.isArray(data.students) && Array.isArray(data.assessments)
}

export function loadData(): AppData {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return demoData
    const parsed: unknown = JSON.parse(raw)
    return isAppData(parsed) ? parsed : demoData
  } catch {
    return demoData
  }
}

export function saveData(data: AppData): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function parseBackup(text: string): AppData {
  if (text.length > 5_000_000) throw new Error('Tệp sao lưu vượt quá giới hạn 5 MB.')
  const parsed: unknown = JSON.parse(text)
  if (!isAppData(parsed)) throw new Error('Tệp không đúng định dạng Saola Feedback v1.')
  return parsed
}
